<template>
  <div class="checkbox-input">
    <div class="form-group row">
      <label v-if="options.label" :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="checkbox mt-2">
          <label class="switch">
            <input type="checkbox"
              :id="options.name"
              :checked="value"
              :name="options.name"
              @change="validate($event.target.checked)"/>
              <span v-html="options.checkboxAllTimeLabel"></span>
              <span class="slider round"></span>
          </label>
        </div>
        <div v-show="value && options.checkboxLabel" class="form-section-success" v-html="options.checkboxLabel"></div>
        <div v-show="!value && options.checkboxOffLabel" class="form-section-info" v-html="options.checkboxOffLabel"></div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/vuex/api'
import {
  S3_BUCKET_URL,
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CheckboxInput',
  props: {
    value: {
      type: Boolean
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          checkboxLabel: '',
          checkboxOffLabel: '',
          checkboxAllTimeLabel: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      S3_BUCKET_URL,
      isDirty: false,
      isValid: false,
      choices: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      return this.options.invalidMessage ? this.options.invalidMessage : 'Invalid value!'
    }
  },
  methods: {
    async updateTOELink (val) {
      let instance = new Api()
      let quoteTypeDetail = await instance.getQuoteTypeDetail(val)
      if (quoteTypeDetail.TermsOfEngagement && quoteTypeDetail.TermsOfEngagement.objectKey) {
        this.options.checkboxAllTimeLabel = `I have read the <a target="_blank" href="${this.S3_BUCKET_URL}${quoteTypeDetail.TermsOfEngagement.objectKey}">‘Terms of Engagement’</a> for ${quoteTypeDetail.quoteName}`
      }
    },
    async runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        if (!this.value) this.watcher = true
        if (this.watcher) {
          if (val) {
            switch (name) {
              case 'QuoteTypeUuid':
                await this.updateTOELink(val)
                break
            }
          }
        }
        this.watcher = true
      }
    },
    validate (val = this.value) {
      this.$emit('input', val)
      if (this.options.required) {
        this.isDirty = true
        this.isValid = val
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CheckboxInput.vue